module.exports = __webpack_public_path__ + "static/media/eye.20d6e4ea.svg";